// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"book-unknown"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M2 3H9C10.6569 3 12 4.34315 12 6V21H11C11 21 8 20 2 20V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M22 3H15C13.3431 3 12 4.34315 12 6V21H13C13 21 16 20 22 20V3Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 21V6M12 21H11C11 21 8 20 2 20V3H9C10.6569 3 12 4.34315 12 6M12 21H13C13 21 16 20 22 20V3H15C13.3431 3 12 4.34315 12 6","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 10.5C15 9.39543 15.8954 8.5 17 8.5C18.1046 8.5 19 9.39543 19 10.5C19 12.5 17.0034 12.5278 17.0034 12.75M17 15.5H17.0039V15.5039H17V15.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BookUnknownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'book-unknown',
    ref,
    icon: element,
  },
));

BookUnknownIcon.displayName = 'BookUnknownIcon';

export default BookUnknownIcon;
